import type { SizeTrimmed } from "~/common/interfaces/size-trimmed";

export const getSizeDefault = (): SizeTrimmed => ({
	id: 0,
	width: 0,
	height: 0,
	length: 0
});
